<template>
  <el-tabs
    :id="tabId"
    v-model="currentName"
    class="top-tabs fixed-top"
    :class="`top-tabs-${displayType} ${isLeft ? (isLeftContent ? 'top-tabs-content' : 'top-tabs-left') : ''} ${isTabbarTop ? 'top-tabs-barup' : ''}`"
    @tab-click="handleClick"
  >
    <el-tab-pane v-for="item in tabsList" :key="item.name" :label="item.label" :name="item.name" :disabled="isDisabled">
      <div v-if="item.tabSlot" slot="label">
        <slot :name="item.name"></slot>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

export default {
  name: 'TopTabs',
  props: {
    // 当前tab
    value: {
      type: String,
      default: ''
    },
    // 组件id
    tabId: {
      type: String,
      default: 'topTabs'
    },
    tabsList: {
      type: Array,
      default: () => []
    },
    isLeft: {
      type: Boolean,
      default: false
    },
    isLeftContent: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // 高亮导航条是否在文字顶部
    isTabbarTop: {
      type: Boolean,
      default: false
    },
    // 额外自定义的展示类型，通过类名样式区分：flex平铺分布, block显示成块
    displayType: {
      type: String,
      default: ''
    },
    emitHandleTapsOnly: {
      type: Boolean,
      default: false
    },
    needFadeTab: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentName: ''
    };
  },
  watch: {
    currentName(newVal, oldVal) {
      this.$emit('update:value', newVal);
      if (newVal !== oldVal && this.needFadeTab) {
        // 淡入淡出
        document.querySelector(`#${this.tabId}`).nextElementSibling.classList.add('fade');
        this.timer = setTimeout(() => {
          document.querySelector(`#${this.tabId}`).nextElementSibling.classList.remove('fade');
        }, 500);
      }
    },
    value: {
      handler(val) {
        this.currentName = val || this.tabsList[0].name;
      },
      immediate: true
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  created() {},
  mounted() {
    // 由于有过渡效果影响吸顶tab，所以需要关闭页面过渡效果
    document.querySelector(`#${this.tabId}`).parentElement.style.transition = 'none';
  },
  methods: {
    handleClick() {
      if (this.emitHandleTapsOnly) {
        this.$emit('handleTaps', this.currentName);
        return;
      }

      // 回到顶部
      document.querySelector('.app-main').scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      this.$emit('handleTaps', this.currentName);
    }
  }
};
</script>

<style lang="scss">
.hideSidebar {
  #topTabs {
    padding-left: 0px !important;
  }
}

#topTabs {
  position: fixed;
  top: 56px;
  right: 0;
  z-index: 12;
  padding-left: $sideBarWidth;
  width: 100%;
  & + div {
    margin-top: 58px;

    &.fade {
      animation-name: fade;
      animation-duration: 0.5s;
    }

    @keyframes fade {
      0% {
        opacity: 1;
        transform: translateX(0);
      }

      50% {
        opacity: 0;
        transform: translateX(-30px);
      }

      100% {
        opacity: 1;
        transform: translateX(0);
      }
    }
  }
}
</style>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
  width: 100%;
  height: 46px;
  line-height: 46px;
  background: #fff;
  margin: 0;
}

::v-deep .el-tabs__nav-scroll {
  display: flex;
}

::v-deep .el-tabs__nav {
  display: flex;
  margin: 0 auto;
}

::v-deep .el-tabs__nav-wrap::after {
  display: none;
}

::v-deep .el-tabs__item {
  height: 46px;
  line-height: 46px;
}
.top-tabs-left {
  ::v-deep .el-tabs__nav {
    margin-left: 30px;
  }
}

.top-tabs-content {
  ::v-deep .el-tabs__nav {
    margin-left: 80px;
  }
}

.top-tabs-flex {
  ::v-deep .el-tabs__header {
    box-shadow: 0px -1px 0px 0px #e5e6eb inset;
    .el-tabs__nav {
      flex: 1;
      .el-tabs__item {
        flex: 1;
        padding: 0px;
        text-align: center;
      }
    }
  }
}

.top-tabs-block {
  ::v-deep .el-tabs__header {
    background-color: #f7f8fa;
    .el-tabs__nav {
      margin: 0;
      .el-tabs__item {
        box-shadow: -1px 0px 0px 0px #e5e6eb inset;
        padding: 0px;
        width: 112px;
        text-align: center;
        &.is-active {
          box-shadow: none;
          background-color: #ffffff;
        }
      }
    }
  }
}

.top-tabs-barup {
  ::v-deep .el-tabs__active-bar {
    top: 0;
  }
}
</style>
